import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FramerService {

  env = environment;

  constructor(private http: HttpClient) { }

  GetToken(params: any) {
    return this.http.post(this.env.webApiUrl + 'api/Framer/GetTokenFromVisitId', params);
  }
  UpdateVisitId(params: any) {
    return this.http.post(this.env.webApiUrl + 'api/Framer/UpdateVisitId', params);
  }
}
